<template>
  <v-text-field
    variant="outlined"
    base-color="type-primary"
    bg-color="white"
  >
    <template
      v-for="(slot, index) of Object.keys($slots)"
      :key="index"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope || {}"
      />
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import '#ui-sass/components/VInput/VInput.scss'
import '#ui-sass/components/VField/VField.scss'
</script>
